import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open() {
    this.element.showModal()
  }

  openNamed(event) {
    const dialogName = event.params.name
    const dialog = document.querySelector(`[data-dialog-name="${dialogName}"]`)
    dialog?.showModal()
  }

  close() {
    this.element.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }
}
